import { SavingsGoalMenu } from '@unistocks/features/savings-goals/components/savings-goal-menu';
import { useSavingsGoalsGetQuery } from '@unistocks/proxy/axios-client/SavingsGoalsQuery';
import { HasId } from '@unistocks/types/has-id';
import { memo } from 'react';

export const SavingsGoalsHeaderRight = memo<HasId>(({ id }) => {
  const { data: savingsGoal, isSuccess } = useSavingsGoalsGetQuery({ id });

  return isSuccess ? <SavingsGoalMenu savingsGoal={savingsGoal} /> : null;
});

SavingsGoalsHeaderRight.displayName = 'SavingsGoalsHeaderRight';
